module.exports = "<ng-content></ng-content>\n"


//////////////////
// WEBPACK FOOTER
// ./src/@fuse/components/widget/widget.component.html
// module id = ./src/@fuse/components/widget/widget.component.html
// module chunks = main